var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFarmingAiri = function SvgFarmingAiri(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    rx: 19.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M18.002 3.133a17.321 17.321 0 0 0-7.163 2.569l4.283 1.056 2.88-3.625Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m13.005 9.432 2.117-2.677-4.283-1.044 2.166 3.721Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M13.006 9.432 10.84 5.711l-.883 4.321 3.049-.6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M10.84 5.71a17.34 17.34 0 0 0-5.238 5.187l4.355-.877.884-4.31ZM9.352 13.052l.605-3.013-4.355.876 3.75 2.137ZM15.125 6.758l2.88.72V3.133l-2.88 3.625ZM3 18.019h4.368l-.714-3.097L3 18.019Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m9.352 13.05-3.75-2.136 1.052 4.25 2.698-2.113Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M5.602 10.914A16.866 16.866 0 0 0 3 18.02l3.654-2.856-1.052-4.25ZM15.126 6.75l-2.118 2.665a12.873 12.873 0 0 1 4.997-1.957l-2.88-.708ZM13.007 9.43l-3.037.6-.617 3.013a13.04 13.04 0 0 1 3.654-3.613ZM9.353 13.047l-2.686 2.1.713 2.858c.29-1.801.98-3.482 1.973-4.958ZM3 21.992A17.014 17.014 0 0 0 5.59 29.1l1.064-4.25L3 21.992Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m9.341 26.945-2.686-2.101-1.065 4.25 3.751-2.15ZM5.602 29.094a17.338 17.338 0 0 0 5.226 5.197l-.883-4.32-4.343-.877Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m12.993 30.573-3.036-.612.87 4.333 2.166-3.72ZM6.654 24.85l.714-2.858H3l3.654 2.857ZM18.003 36.873v-4.334l-3.122.696 3.122 3.638Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m12.994 30.57-2.166 3.722 4.283-1.057-2.117-2.665ZM10.828 34.294a17.33 17.33 0 0 0 7.175 2.581l-2.88-3.625-4.295 1.044ZM6.655 24.85l2.686 2.1a12.656 12.656 0 0 1-1.972-4.958l-.714 2.857ZM9.342 26.953l.605 3.013 3.037.612a13.202 13.202 0 0 1-3.642-3.625Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m12.994 30.57 2.117 2.665 2.892-.696a13.215 13.215 0 0 1-5.009-1.969ZM22.004 36.875a17.324 17.324 0 0 0 7.163-2.569l-4.283-1.056-2.88 3.625ZM27.002 30.57l-2.117 2.665 4.27 1.057-2.153-3.722ZM27.002 30.561l2.153 3.721.883-4.321-3.037.6Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M29.154 34.28a17.339 17.339 0 0 0 5.239-5.186l-4.356.876-.883 4.31ZM30.654 26.945l-.617 3.013 4.355-.864v-.012l-3.738-2.137ZM24.884 33.235l-2.88-.696v4.334l2.88-3.638ZM36.994 21.977h-4.367l.713 3.097 3.654-3.097Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m30.656 26.949 3.739 2.136-1.053-4.25-2.686 2.114Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M34.395 29.087a17.022 17.022 0 0 0 2.602-7.118l-3.654 2.857 1.052 4.261ZM24.884 33.235l2.117-2.665a12.873 12.873 0 0 1-4.997 1.957l2.88.708ZM27.002 30.574l3.036-.6.617-3.013a13.537 13.537 0 0 1-3.654 3.613ZM30.656 26.95l2.686-2.1-.714-2.858a12.802 12.802 0 0 1-1.972 4.958ZM37 18.02a17.015 17.015 0 0 0-2.59-7.106l-1.065 4.25L37 18.02Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m30.659 13.063 2.686 2.1 1.065-4.249-3.751 2.149ZM30.659 13.06l3.75-2.149-4.367-.864.617 3.013ZM34.408 10.909a17.34 17.34 0 0 0-5.227-5.198l.883 4.321 4.344.877ZM27.003 9.432l3.037.612-.87-4.333-2.167 3.721ZM33.345 15.164l-.714 2.857H37l-3.654-2.857ZM22.007 3.133v4.345l3.121-.708-3.121-3.637Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m27.004 9.432 2.166-3.721-4.283 1.056 2.117 2.665Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M29.17 5.714a17.328 17.328 0 0 0-7.174-2.581l2.88 3.625 4.294-1.044ZM33.345 15.163l-2.686-2.1a12.657 12.657 0 0 1 1.972 4.957l.714-2.857ZM30.66 13.055l-.605-3.013-3.037-.612a13.04 13.04 0 0 1 3.642 3.625ZM27.004 9.438l-2.117-2.665-2.88.709c1.827.3 3.52.984 4.997 1.956ZM20.002 9.68l-3.049 5.234h6.11l-3.06-5.234ZM23.063 14.914l-3.061 5.246H26.1l-3.037-5.246ZM26.1 20.164l-3.038 5.246h6.098l-3.06-5.246ZM16.953 25.41l3.049-5.246h-6.098l3.049 5.246Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m23.063 25.41 3.037-5.246h-6.098l3.061 5.246ZM20.002 20.16l3.061-5.246h-6.11l3.05 5.246ZM13.904 20.164l-3.049 5.246h6.098l-3.049-5.246ZM20.002 9.68l-3.049 5.234h6.11l-3.06-5.234Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m23.063 14.914-3.061 5.246H26.1l-3.037-5.246ZM26.1 20.164l-3.038 5.246h6.098l-3.06-5.246ZM16.953 25.41l3.049-5.246h-6.098l3.049 5.246Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m23.063 25.41 3.037-5.246h-6.098l3.061 5.246ZM20.002 20.16l3.061-5.246h-6.11l3.05 5.246ZM13.904 20.164l-3.049 5.246h6.098l-3.049-5.246ZM9.34 26.953l.617 3.013-4.355-.864 3.738-2.149Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    x: 0.5,
    y: 0.5,
    stroke: "#F0F2FA",
    rx: 19.5
  })));
};
export default SvgFarmingAiri;